module.exports = __webpack_public_path__ + "static/media/31JFA7.15b1f37f.jpg";